import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useForm, Controller } from 'react-hook-form';
import CircularProgress from '@mui/material/CircularProgress';
import { Label } from '@/shadcn/components/Label';
import { Input } from '@/shadcn/components/Input';
import { Button } from '@/shadcn/components/Button';
import { Checkbox } from '@/shadcn/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SignUpForm = _ref => {
  let {
    hasActiveSession,
    teamId,
    email,
    isLoading,
    disabled,
    errors: additionalErrors = {},
    onSubmit,
    onNewsletterChange
  } = _ref;
  const {
    register,
    control,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    defaultValues: {
      name: '',
      email,
      password: '',
      subscribeToNewsletter: false
    }
  });

  const triggerOnSumit = _ref2 => {
    let {
      name,
      email,
      password,
      subscribeToNewsletter
    } = _ref2;
    return onSubmit({
      name,
      email,
      password,
      team: teamId,
      newsletter: subscribeToNewsletter
    });
  };

  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(triggerOnSumit),
    children: [additionalErrors.team ? /*#__PURE__*/_jsx("p", {
      className: "mt-2 text-xs text-red-600",
      children: additionalErrors.team
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsxs("div", {
      className: "grid gap-4",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "grid gap-2",
        children: [/*#__PURE__*/_jsx(Label, {
          htmlFor: "email",
          children: "Name"
        }), /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
          id: "name",
          placeholder: "Your name",
          required: true
        }, register('name', {
          required: 'Please enter an name',
          minLength: {
            value: 3,
            message: 'name should have at least 3 characters'
          }
        })), {}, {
          name: "name"
        })), errors.name || additionalErrors.name ? /*#__PURE__*/_jsx("p", {
          className: "mt-2 text-xs text-red-600",
          children: errors.name ? errors.name.message : additionalErrors.name
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      }), /*#__PURE__*/_jsxs("div", {
        className: "grid gap-2",
        children: [/*#__PURE__*/_jsx(Label, {
          htmlFor: "email",
          children: "Email address"
        }), /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
          id: "email",
          type: "email",
          placeholder: "m@example.com",
          required: true
        }, register('email', {
          required: 'Please enter an email',
          pattern: {
            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Not a valid email'
          }
        })), {}, {
          name: "email"
        })), errors.email || additionalErrors.email ? /*#__PURE__*/_jsx("div", {
          className: "mt-2 text-xs text-red-600",
          children: errors.email ? errors.email.message : additionalErrors.email
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      }), /*#__PURE__*/_jsxs("div", {
        className: "grid gap-2",
        children: [/*#__PURE__*/_jsx(Label, {
          htmlFor: "email",
          children: "Password"
        }), /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
          id: "password",
          autoComplete: "new-password",
          placeholder: "Your password",
          required: true,
          type: "password"
        }, register('password', {
          required: 'Please enter a password',
          minLength: {
            value: 6,
            message: 'Should have at least 6 characters'
          }
        })), {}, {
          name: "password"
        })), errors.password || additionalErrors.password ? /*#__PURE__*/_jsx("div", {
          className: "mt-2 text-xs text-red-600",
          children: errors.password ? errors.password.message : additionalErrors.password
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center space-x-2",
        children: [/*#__PURE__*/_jsx(Controller, {
          name: "subscribeToNewsletter",
          control: control,
          render: _ref3 => {
            let {
              field
            } = _ref3;
            return /*#__PURE__*/_jsx(Checkbox, {
              id: "subscribeToNewsletter",
              checked: field.value,
              onCheckedChange: checked => {
                field.onChange(checked);
                typeof onNewsletterChange === 'function' && onNewsletterChange(checked === 'indeterminate' ? true : checked);
              }
            });
          }
        }), /*#__PURE__*/_jsx("label", {
          htmlFor: "subscribeToNewsletter",
          className: "text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
          children: "Be notified of latest feature releases, promotions, and more."
        })]
      }), /*#__PURE__*/_jsx(Button, {
        type: "submit",
        className: "w-full",
        disabled: isLoading || hasActiveSession || disabled,
        children: isLoading ? /*#__PURE__*/_jsx(CircularProgress, {
          size: 20,
          color: "inherit"
        }) : 'Sign up'
      })]
    })]
  });
};

export default SignUpForm;